import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: inline-block;\n  ",
        "\n\n  svg {\n    display: block;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
const Icon = (param)=>{
    let { icon: IconComponent , onClick , className , ...props } = param;
    return /*#__PURE__*/ _jsx(IconWrapper, {
        isButton: !!onClick,
        onClick: onClick,
        className: className,
        children: /*#__PURE__*/ _jsx(IconComponent, {
            ...props
        })
    });
};
export default Icon;
const IconWrapper = styled.i.withConfig({
    componentId: "sc-f2523ccb-0"
})(_templateObject(), (props)=>props.isButton && "cursor: pointer;");
